import MuiToggleButtonGroup, {
  ToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup';

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  ...props
}) => {
  return <MuiToggleButtonGroup {...props}></MuiToggleButtonGroup>;
};
